import { RopeRole } from './types'

export type RopeRoleStyle = {
  role: RopeRole
  label: string
  // Default stroke colour applied when the role is assigned. The per-rope
  // `color` remains editable afterwards.
  color: string
  // Dash pattern (world pixels) used to distinguish the role on the canvas;
  // `null` renders a solid line. Backup lines (safety/backup) are dashed.
  dash: number[] | null
  description: string
}

// Ordered for display in pickers/legend.
export const ROPE_ROLES: RopeRoleStyle[] = [
  { role: 'working', label: 'Working', color: '#dc2626', dash: null, description: 'Main line under load' },
  { role: 'safety', label: 'Safety', color: '#2563eb', dash: [16, 10], description: 'Independent backup line' },
  { role: 'haul', label: 'Haul', color: '#ea580c', dash: null, description: 'Raising / hauling line' },
  { role: 'backup', label: 'Backup', color: '#7c3aed', dash: [4, 8], description: 'Protective backup line' },
]

const ROLE_BY_KEY: Record<RopeRole, RopeRoleStyle> = ROPE_ROLES.reduce(
  (acc, style) => {
    acc[style.role] = style
    return acc
  },
  {} as Record<RopeRole, RopeRoleStyle>,
)

export function getRopeRoleStyle(role: RopeRole | undefined): RopeRoleStyle | null {
  if (!role) return null
  return ROLE_BY_KEY[role] ?? null
}

/** Set of default colours used by any role — for detecting un-customised ropes. */
const ROLE_DEFAULT_COLORS = new Set(ROPE_ROLES.map((s) => s.color))

export function isRoleDefaultColor(color: string): boolean {
  return ROLE_DEFAULT_COLORS.has(color)
}

export const DEFAULT_ROPE_ROLE: RopeRole = 'working'
